'use client';

export interface AgencyProfile {
  id: number;
  slug: string;
  name: string;
  shortName: string;
  city: string;
  address: string;
  phone: string;
  whatsapp: string;
  email: string;
  rc: string;
  ice: string;
  patente: string;
  logoText: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColor: string;
  secondaryColor: string;
  currency: string;
  rateEur: number;
  rateUsd: number;
  contractFooter: string;
  pickupLocations: string[];
  whatsappTemplate: string;
}

export const DEFAULT_AGENCY: AgencyProfile = {
  id: 0,
  slug: 'agadir',
  name: 'fleetava Agence Agadir',
  shortName: 'fleetava',
  city: 'Agadir',
  address: 'Av. Hassan II, Agadir 80000',
  phone: '+212528840000',
  whatsapp: '+212661000000',
  email: 'contact@fleetava-agadir.ma',
  rc: 'RC 123456',
  ice: 'ICE 00234567800001',
  patente: 'Patente 45678901',
  logoText: 'fleetava',
  logoUrl: '',
  faviconUrl: '',
  primaryColor: '#FF8A00',
  secondaryColor: '#0d1117',
  currency: 'DH',
  rateEur: 10.8,
  rateUsd: 10.0,
  contractFooter: "Contrat établi en deux exemplaires. Tout litige relève des tribunaux d'Agadir.",
  pickupLocations: [],
  whatsappTemplate: '',
};

export function officeLocations(agency: { pickupLocations?: string[] | null }, fallback: string[]): string[] {
  const raw = agency.pickupLocations;
  const saved = Array.isArray(raw) ? raw.map((item) => item.trim()).filter(Boolean) : [];
  return saved.length > 0 ? saved : fallback;
}

const STORAGE_KEY = 'fleetava_agency';

export function loadAgency(): AgencyProfile {
  if (typeof window === 'undefined') return DEFAULT_AGENCY;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_AGENCY;
    const parsed = JSON.parse(raw) as Partial<AgencyProfile>;
    return { ...DEFAULT_AGENCY, ...parsed };
  } catch {
    return DEFAULT_AGENCY;
  }
}

export function saveAgency(a: AgencyProfile): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(a));
  } catch {
    // storage unavailable — ignore
  }
}
